import Svg from '@doordash/component-svg'
import * as React from 'react'
import { ImageProps } from '../'
import t from './strings'

// tslint:disable:max-line-length
export const Freedom: React.FunctionComponent<ImageProps> = ({
  width,
  height,
}) => (
  <Svg
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 60 56"
    aria-labelledby="valuePropsTitleFreedom valuePropsDescFreedom"
    role="img"
  >
    <title id="valuePropsTitleFreedom">{t.title()}</title>
    <desc id="valuePropsDescFreedom">{t.desc()}</desc>
    <defs>
      <path id="a" d="M0 .3h29.5v45.8H0z" />
      <path id="c" d="M0 .3h23V45H0z" />
      <path id="e" d="M0 0h15.3v23H0z" />
      <path id="g" d="M0 0h15.3v23H0z" />
      <path id="i" d="M0 0h15.3v23H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path d="M0-2h60v60H0z" />
      <g transform="translate(0 9.5)">
        <mask id="b" fill="#fff">
          <use xlinkHref="#a" />
        </mask>
        <path
          fill="#EBEAE0"
          d="M14.7.3C14 2.4 0 26.5 0 26.5S18.8 49 19.8 45.8c1-3.2 12.7-37.5 8.9-39L14.7.2"
          mask="url(#b)"
        />
      </g>
      <path
        fill="#E6E5D8"
        d="M38.2 10.6l-1 30.1s-17 15.7-17.5 14.6c-.7-1 8.6-39.4 8.6-39.4l9.9-5.3z"
      />
      <g transform="translate(37 10.6)">
        <mask id="d" fill="#fff">
          <use xlinkHref="#c" />
        </mask>
        <path
          fill="#F1F1EA"
          d="M13.4 6.1S23.3 44.3 23 45c-.5.7-23-14.6-23-14.6v-17C.1 6.7.8.2.8.2L13.4 6z"
          mask="url(#d)"
        />
      </g>
      <path
        fill="#D4D3C8"
        d="M27.7 16s-8.6 38.3-8 39.3c.8-3.2 11.4-37.6 8-39.2"
      />
      <path
        fill="#457C7C"
        d="M27.4 20.1c1 0 10-6.5 10.6-6.1.6.3 12.7 7.5 13.2 7.5.4 0-.9-4.5-.9-4.5s-11.4-6.4-12-6.2c-.6.1-9.7 5.4-10.2 5.4-.6 0-13.6-6.7-13.6-6.7S13 12.1 13 12.4c.2.5 13.5 7.7 14.3 7.7z"
      />
      <g transform="translate(2.2)">
        <mask id="f" fill="#fff">
          <use xlinkHref="#e" />
        </mask>
        <path
          fill="#FF4D2B"
          d="M7.8 23C7.6 23-.6 12 0 6.4A7.6 7.6 0 019.7.3c4 1.2 6.1 5 5.5 8.3C14 13.9 8 22.8 7.8 22.9"
          mask="url(#f)"
        />
      </g>
      <path
        fill="#3B646E"
        d="M27.4 20l.6-3.5L38.2 11l-.4 3.4c-.3.3-10.4 5.7-10.4 5.7z"
      />
      <path
        stroke="#FFF"
        strokeWidth="0.8"
        d="M15.3 7.7a5 5 0 01-1.6 4c-1 1-2.2 1.4-3.5 1.4-2.4 0-3.2-.4-4.8-2-.8-1-1.3-3.5-1-4.6C5 5 5.5 3.9 6.9 3c2.7-1.6 6.4-1 7.8 1.8.4.9.7 1.8.7 2.8"
      />
      <g transform="translate(44.7 12)">
        <mask id="h" fill="#fff">
          <use xlinkHref="#g" />
        </mask>
        <path
          fill="#FF4D2B"
          d="M7.8 23C7.6 23-.6 12 0 6.4A7.6 7.6 0 019.7.3c4 1.2 6.1 5 5.5 8.3C14 13.9 8 22.8 7.8 22.9"
          mask="url(#h)"
        />
      </g>
      <path
        stroke="#FFF"
        strokeWidth="0.8"
        d="M57.8 19.7a5 5 0 01-1.6 4c-.9 1-2.2 1.4-3.5 1.4-2.4 0-3.1-.4-4.7-2-.9-1-1.3-3.5-1-4.6.5-1.5 1-2.6 2.3-3.4 2.8-1.6 6.4-1 7.8 1.8.5.9.8 1.8.7 2.8"
      />
      <g transform="translate(17.5 23)">
        <mask id="j" fill="#fff">
          <use xlinkHref="#i" />
        </mask>
        <path
          fill="#DC3119"
          d="M7.8 23C7.6 23-.6 12 0 6.4A7.6 7.6 0 019.7.3c4 1.2 6.1 5 5.5 8.3C14 13.9 8 22.8 7.8 22.9"
          mask="url(#j)"
        />
      </g>
      <path
        stroke="#FFF"
        strokeWidth="0.8"
        d="M30.5 30.6a5 5 0 01-1.6 4c-.9 1-2.2 1.4-3.5 1.4-2.3 0-3-.4-4.7-2-.8-.9-1.3-3.5-1-4.6.5-1.5 1-2.6 2.4-3.4 2.7-1.6 6.4-1 7.8 1.8.4.9.7 1.8.6 2.8"
      />
    </g>
  </Svg>
)

export default Freedom
